import React, {useState} from 'react';

import {colors} from 'js-libs/sweetcommons/styles';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';

import {KBArticleFeedbackModal} from './KBArticleFeedbackModal';

import type {KBArticleSerializedType} from 'sweet-types';

interface Props {
  article: KBArticleSerializedType;
}

export function KBArticleFeedbackChart({article}: Props): JSX.Element {
  const [showingModal, showModal] = useState<boolean>(false);
  const {positive, total} = article.feedback;
  const mounted = React.useRef(false);

  function wrapInButtonOrSpan(children: React.ReactNode) {
    return total > 0 ? (
      <button
        className="flex-shrink-0 p-0 btn btn-link"
        onClick={() => {
          mounted.current = true;
          showModal(true);
        }}
      >
        {children}
      </button>
    ) : (
      <span className="flex-shrink-0">{children}</span>
    );
  }

  return (
    <>
      <LazyTooltip
        tooltip={
          <small>
            {total === 0
              ? gt('No feedback was received for this article yet')
              : gt(
                  '%s out of %s people found this article helpful',
                  positive,
                  total
                )}
          </small>
        }
      >
        {wrapInButtonOrSpan(
          <svg height="20" width="20" viewBox="0 0 20 20">
            <circle
              r="10"
              cx="10"
              cy="10"
              fill="white"
              stroke={colors.borderGray}
            />
            {total > 0 ? (
              <>
                <circle r="8" cx="10" cy="10" fill="#f1c8c8" />
                <circle
                  r="4"
                  cx="10"
                  cy="10"
                  fill="transparent"
                  stroke="#c8eec8"
                  strokeWidth="8"
                  strokeDasharray={`${(positive / total) * 25.12} 25.12`}
                  transform="rotate(-90) translate(-20)"
                />
              </>
            ) : null}
          </svg>
        )}
      </LazyTooltip>
      {mounted.current ? (
        <KBArticleFeedbackModal
          article={article}
          show={showingModal}
          onClose={() => showModal(false)}
        />
      ) : null}
    </>
  );
}
